module.exports = __webpack_public_path__ + "static/media/elsa-jean-lose.7c4e6ebe.jpg";